module.exports = __webpack_public_path__ + "img/modal-header-bg.9c8b9059.png";